import { MockFactory } from '@tino-frontend/mocks'
import {
  CheckUnicoResultResponse,
  CheckUnicoResultResponseResult,
} from '@types'

export const CheckUnicoResultResponseRejectMock =
  new MockFactory<CheckUnicoResultResponse>({
    result: CheckUnicoResultResponseResult.REJECT,
  })
